module.exports = __webpack_public_path__ + "img/select.6ad886e5.svg";